import React, { useEffect, useState } from "react";
import Loader from "../../components/common/loader";
import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Label,
  Row,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { digitRegex, InputPlaceHolder, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import Flatpickr from "react-flatpickr";
import BreadCrumb from "../../components/common/breadCrumb";
import { checkStatusCodeSuccess, CommonLabel, dateFormatChange, errorHandler } from "../../utils/helpers/common";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  addSeniorTaskSheet,
  editSeniorTaskSheet,
  listOfSeniorProject,
  listOfSeniorTaskSheet,
  listofjunior,
} from "../../api/tasksheetApi";
import { listOfAssignCourse } from "../../api/itpApi";
import { getId, getName } from "../../utils/helpers/custom";
import { MinutesOption } from "../../utils/helpers/enums";
import { toast } from "react-toastify";
import { BaseSelect } from "../../components/BaseComponents/BaseSelect";
import BaseInput from "../../components/BaseComponents/BaseInput";
import { TaskLabel } from "../../common/constant/Task";
import BaseButton from "../../components/BaseComponents/BaseButton";

const TasksheetAddEdit = () => {
  const { tasksheet_id } = useParams();
  const [loading, setLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [pageTitle, setPageTitle] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isEdit, setIsEdit] = useState();
  const [editTaskSheetData, setEditTaskSheetData] = useState("");
  const [listOfEmployees, setListOfEmployees] = useState([]);
  const [listOfDataState, setListOfDataState] = useState([]);
  const [selectedProject, setSelectedProject] = useState([]);
  const [traineeCourseList, setTraineeCourseList] = useState([]);
  const [courseId, setCourseId] = useState();
  const id = getId();
  const existingUser = {
    label: getName(),
    value: id,
  };
  document.title = pageTitle;
  const navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    if (!isNaN(tasksheet_id)) {
      setIsEdit(true);
      setPageTitle(TaskLabel.EditTasksheet);
      setLoading(true);
      listOfSeniorTaskSheet({
        id: tasksheet_id,
      })
        .then((res) => {
          setEditTaskSheetData(res?.data?.data?.listOfSeniorTaskSheet[0]);
        })
        .catch((err) => {
          setLoading(false);
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setIsEdit(false);
      setPageTitle(TaskLabel.AddTasksheet);
    }

    listofjunior()
      .then((res) => {
        setListOfEmployees(
          res?.data?.data?.map((res) => ({
            value: res?.id,
            label: res?.developerName,
          }))
        );
      })
      .catch((err) => err);

    listOfSeniorProject({
      condition: {
        assignTo: id,
      },
    })
      .then((response) => {
        const newData = response?.data?.data?.map((item) => ({
          value: item?.project?.id,
          label: item?.project?.projectName,
        }));
        setListOfDataState(newData);
      })
      .catch((err) => {
        setLoading(false);
        return err;
      })
      .finally(() => {
        setListOfDataState((prevState) => {
          if (Array.isArray(prevState)) {
            return [TaskLabel.TraineeOption, ...prevState];
          } else {
            return [TaskLabel.TraineeOption];
          }
        });
        setLoading(false);
      });

    listOfAssignCourse({
      assignTo: Number(id)
    })
      .then((response) => {
        setTraineeCourseList(
          response?.data?.data?.map((res) => ({
              value: res?.course?.id,
              label: res?.course?.courseName,
          }))
        );
      })
      .catch((err) => {
        setLoading(false);
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  }, [tasksheet_id]);

  let editTaskSheetHours = isEdit
    ? String(editTaskSheetData?.hours)
    : editTaskSheetData?.hours;

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      projectName: listOfDataState?.find((item)=> item?.label===editTaskSheetData?.projectName)?.value || "",
      projectTask: editTaskSheetData?.taskName || "",
      taskDetails: editTaskSheetData?.taskDetails || "",
      date: isEdit
        ? `${editTaskSheetData?.startDate} to ${editTaskSheetData?.endDate}`
        : "",
      hours: editTaskSheetHours || "",
      minutes: String(editTaskSheetData?.minutes) || "",
      assignto: editTaskSheetData?.assignTo || "",
      courseName: editTaskSheetData?.courseName || "",
    },
    validationSchema: Yup.object().shape({
      projectName: Yup.string().required(validationMessages.required(TaskLabel.ProjectName)),
      projectTask: Yup.string().required(validationMessages.required(TaskLabel.TaskName)),
      taskDetails: Yup.string().required(validationMessages.required(TaskLabel.TaskDetail)),
      date: Yup.string().required(validationMessages.required(TaskLabel.Date)),
      hours: Yup.string().required(validationMessages.required(TaskLabel.Hour)),
      minutes: Yup.string().optional(),
      assignto: Yup.string().required(validationMessages.required(TaskLabel.DeveloperName)),
    }),
    onSubmit: (value) => {
      setBtnLoader(true);
      const payload = {
        ...(isEdit ? { id: Number(tasksheet_id) } : { addedBy: Number(id) }),
        projectName: listOfDataState?.find((item)=> item?.value === value?.projectName)?.label,
        taskName: value?.projectTask,
        taskDetails: value?.taskDetails,
        startDate: startDate,
        endDate: endDate,
        hours: +value?.hours,
        minutes: +value?.minutes,
        assignTo: value?.assignto,
      };
      if (isEdit) {
        editSeniorTaskSheet(payload)
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              toast.success(res?.data?.message);
              validation.resetForm();
              navigate("/tasksheet");
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => {
            errorHandler(err);
          })
          .finally(() => {
            setBtnLoader(false);
          });
      } else {
        setBtnLoader(true);
        if (
          selectedProject === TaskLabel.TraineeOption.label ||
          selectedProject === TaskLabel.TraineeOption.value
        ) {
          payload.courseId = courseId;
        }

        addSeniorTaskSheet(payload)
          .then((res) => {
            if (checkStatusCodeSuccess(res?.data?.statusCode)) {
              toast.success(res?.data?.message);
              validation.resetForm();
              navigate("/tasksheet");
            } else {
              toast.error(res?.data?.message);
            }
          })
          .catch((err) => {
            errorHandler(err);
          })
          .finally(() => {
            setBtnLoader(false);
          });
      }
    },
  });

  return (
    <div className="page-content">
      {loading ? (
        <Loader />
      ) : (
        <Container fluid>
          <BreadCrumb title={pageTitle} pageTitle="HRMS" />
          <Row className="mb-2">
            <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
              <h5 className="fw-semibold mt-2">{pageTitle}</h5>
            </div>
            <div className="col-auto order-2 order-sm-3 ms-auto">
              <div className="hstack gap-2">
                <Link to={"/tasksheet"} className="btn btn-primary">
                  {CommonLabel.Back}
                </Link>
              </div>
            </div>
          </Row>
          <Card>
            <CardBody>
              <Form id="creattask-form" onSubmit={validation.handleSubmit}>
                <Row>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="projectName"
                        placeholder={SelectPlaceHolder(TaskLabel.ProjectName)}
                        label={TaskLabel.ProjectName}
                        options={listOfDataState}
                        value={validation.values.projectName}
                        handleChange={(field, value) => {
                          validation.setFieldValue(field, value);
                          setSelectedProject(value);
                        }}
                        handleBlur={validation.handleBlur}
                        touched={validation.touched.projectName}
                        error={validation.errors.projectName}
                        required={true}
                      />
                    </div>
                  </Col>
                  {(selectedProject === TaskLabel.TraineeOption.label ||
                    selectedProject === TaskLabel.TraineeOption.value) && (
                    <Col lg={6}>
                      <div className="mb-3">
                        <BaseSelect
                          name="courseName"
                          placeholder={SelectPlaceHolder(TaskLabel.CourseName)}
                          label={TaskLabel.CourseName}
                          options={traineeCourseList}
                          value={validation?.values?.courseName}
                          handleChange={(field, value) => {
                            validation.setFieldValue(field, value);
                            setCourseId(value);
                          }}
                          handleBlur={validation.handleBlur}
                          touched={validation.touched.courseName}
                          error={validation.errors.courseName}
                          required={true}
                        />
                      </div>
                    </Col>
                  )}

                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="projectTask"
                        type="text"
                        placeholder={InputPlaceHolder(TaskLabel.TaskName)}
                        label={TaskLabel.TaskName}
                        onChange={validation.handleChange}
                        handleBlur={validation.handleBlur}
                        value={validation?.values?.projectTask}
                        touched={validation.touched.projectTask}
                        error={validation.errors.projectTask}
                        required={true}
                      />
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="mb-3">
                      <Label htmlFor="JoiningdatInput" className="form-label">
                        <span className="required">{TaskLabel.Date}</span>
                      </Label>
                      <Flatpickr
                        id="datepicker-publish-input"
                        className={`form-select ${
                          validation.errors.date && "is-invalid"
                        }`}
                        placeholder="Select a date"
                        name="date"
                        validate={{ required: { value: true } }}
                        onBlur={validation.handleBlur}
                        invalid={
                          !!(
                            validation?.touched?.date &&
                            validation?.errors?.date
                          )
                        }
                        options={{
                          mode: "range",
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          defaultDate: [
                            editTaskSheetData?.startDate,
                            editTaskSheetData?.endDate,
                          ],
                          onChange: function (
                            selectedDates,
                            dateStr,
                            instance
                          ) {
                            validation.setFieldValue("date", dateStr);
                            setStartDate(dateFormatChange(selectedDates[0]));
                            setEndDate(dateFormatChange(selectedDates[1]));
                          },
                        }}
                      />
                      {validation.touched.date && validation.errors.date ? (
                        <div className="invalid-feedback">
                          {validation.errors.date}
                        </div>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <label htmlFor="task-hour-input" className="form-label required">
                        {TaskLabel.EstimateTime} :
                      </label>

                      <div className="input-group">
                        <Row>
                          <Col lg={6}>
                            <BaseInput
                              name="hours"
                              type="text"
                              placeholder={InputPlaceHolder(TaskLabel.Hour)}
                              onChange={(e) => {
                                if (digitRegex.test(e.target.value)) {
                                  validation.handleChange(e);
                                }
                              }}
                              handleBlur={validation.handleBlur}
                              value={validation?.values?.hours}
                              touched={validation.touched.hours}
                              error={validation.errors.hours}
                              maxLength={2}
                              required={true}
                            />
                          </Col>

                          <Col lg={6}>
                            <BaseSelect
                              name="minutes"
                              placeholder={SelectPlaceHolder(TaskLabel.Minutes)}
                              options={MinutesOption}
                              value={validation?.values?.minutes}
                              handleChange={(field, value) => {
                                validation.setFieldValue(field, value);
                              }}
                              handleBlur={validation.handleBlur}
                              touched={validation.touched.minutes}
                              error={validation.errors.minutes}
                              required={false}
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseSelect
                        name="assignto"
                        placeholder={SelectPlaceHolder(TaskLabel.DeveloperName)}
                        label={TaskLabel.DeveloperName}
                        options={listOfEmployees}
                        value={validation?.values?.assignto || existingUser}
                        handleChange={(field, value) => {
                          validation.setFieldValue(field, value);
                        }}
                        handleBlur={validation.handleBlur}
                        touched={validation.touched.assignto}
                        error={validation.errors.assignto}
                        required={true}
                      />
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="mb-3">
                      <BaseInput
                        name="taskDetails"
                        type="textarea"
                        placeholder={InputPlaceHolder(TaskLabel.TaskDetail)}
                        label={TaskLabel.TaskDetail}
                        onChange={validation.handleChange}
                        handleBlur={validation.handleBlur}
                        value={validation?.values?.taskDetails}
                        touched={validation.touched.taskDetails}
                        error={validation.errors.taskDetails}
                        required
                      />
                    </div>
                  </Col>
                </Row>
                <Col lg={12}>
                  <div className="hstack gap-2 justify-content-end">
                    <BaseButton type="submit" color="primary" loader={btnLoader}>
                      {isEdit ? CommonLabel.Update : CommonLabel.Submit}
                    </BaseButton>
                  </div>
                </Col>
              </Form>
            </CardBody>
          </Card>
        </Container>
      )}
    </div>
  );
};

export default TasksheetAddEdit;
